__turbopack_context__.v({
  "container": "MapSection-module-scss-module__tPXl_G__container",
  "image": "MapSection-module-scss-module__tPXl_G__image",
  "imageWrapper": "MapSection-module-scss-module__tPXl_G__imageWrapper",
});
